import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA1DlMApn_VyvCf1dp4D_NxlJ7FmoXXl9c",
  authDomain: "dr-tour-festival.firebaseapp.com",
  projectId: "dr-tour-festival",
  storageBucket: "dr-tour-festival.firebasestorage.app",
  messagingSenderId: "475009759718",
  appId: "1:475009759718:web:08e204f0a7008c3a56fe27",
  measurementId: "G-M51KMT3SQL",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Analytics can throw in some environments (like localhost / blocked cookies), so guard it:
export const analyticsPromise = isSupported().then((yes) => (yes ? getAnalytics(app) : null));